import { TrashIcon } from '@radix-ui/react-icons';
import { Box, Flex, Heading } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonTableCheckedMenu } from 'components/common/table/checked-menu';
import { HittersContext } from 'contexts/hitters.context';
import { CheckedContext } from 'contexts/layout/checked.context';
import { t } from 'i18next';
import { IMenuAction } from 'interfaces/i-menus';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IHitter } from 'lib_ts/interfaces/i-hitter';
import { useContext, useMemo } from 'react';

interface IProps {
  hitters: IHitter[];
}

// only necessary for pitchers view because we don't add avgs for hitters
export const HitterLibraryFooter = (props: IProps) => {
  const { tally, getChecked } = useContext(CheckedContext);
  const { confirmDeleteMany } = useContext(HittersContext);

  const actions = useMemo<IMenuAction[]>(() => {
    const items = props.hitters.filter((m) => getChecked(m._id));
    if (items.length === 0) {
      return [];
    }

    const output: IMenuAction[] = [
      {
        prefixIcon: <TrashIcon />,
        color: RADIX.COLOR.DANGER,
        label: 'common.delete',
        onClick: () => confirmDeleteMany(items),
      },
    ];

    return output;
  }, [tally.key]);

  return (
    <ErrorBoundary identifier="HitterLibraryFooter">
      {actions.length > 0 && (
        <Flex gap={RADIX.FLEX.GAP.SM}>
          <Heading size={RADIX.HEADING.SIZE.MD} mb="1">
            {tally.checked}&nbsp;
            {t('common.selected').toLowerCase()}
          </Heading>
          <Box ml="1" className="valign-center">
            <CommonTableCheckedMenu actions={actions} />
          </Box>
        </Flex>
      )}
    </ErrorBoundary>
  );
};
